import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { track } from './analytics';
import { EVENTS } from './events';

export function usePageViews() {
  const { pathname, search } = useLocation();
  useEffect(() => {
    track(EVENTS.PAGE_VIEW, {
      page_path: pathname + search,
      page_location: window.location.href,
      page_title: document.title,
    });
  }, [pathname, search]);
}

export default function PageViewTracker() {
  usePageViews();
  return null;
}
